import React from "react";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";

import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { getWareHouseDetailsByIdAction } from "src/app-redux/warehouse/actions/wareHouseActions";
import { selectCurrentInventoryItemId } from "src/app-redux/warehouse/wareHouseSlice";
import { useStyles } from "../style";
import DrawerDetails from "./DrawerDetails";
import DrawerHistory from "./DrawerHistory";
import DrawerStatus from "./DrawerStatus";
import DrawerQuantity from "./DrawerQuantity";

export interface IProps {
  heading: string;
  isDrawerOpen: boolean;
  handleCloseDrawer: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1} style={{ marginTop: "10px" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Drawer(props: IProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const currentInventoryItemId = useAppSelector(selectCurrentInventoryItemId);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <CommonDrawer
        heading={props.heading}
        isOpen={props.isDrawerOpen}
        closeDrawer={() => {
          props.handleCloseDrawer();
        }}
        drawerWidth={450}
        iconCallBackFun={() => {
          dispatch(getWareHouseDetailsByIdAction(currentInventoryItemId));
        }}
        border={true}
      >
        <div className={`${classes.mainDrawer}`}>
          <AppBar position="static" color="default" className="">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.DrawerTabs}
            >
              <Tab label="Details" {...a11yProps(0)} />
              <Tab label="History" {...a11yProps(1)} />
              <Tab label="Status" {...a11yProps(2)} />
              <Tab label="Quantity" {...a11yProps(3)} />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0} dir={theme.direction}>
            <DrawerDetails />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <DrawerHistory />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <DrawerStatus />
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <DrawerQuantity />
          </TabPanel>
        </div>
      </CommonDrawer>
    </>
  );
}
